import React from 'react'
import { NavLink, Outlet, Link } from 'react-router-dom'
import styled from 'styled-components'

import Typography from '../components/Typography'
import { theme } from '../theme'

/**
 * Layout for /admin/*. Renders a left sidebar with the admin sections plus a
 * minimal top bar with a back-to-app link. Children are rendered into the
 * <Outlet />.
 *
 * Visual style is intentionally austere: this is a tool for 1-2 internal
 * users, not a marketing surface.
 */
const AdminLayout = () => {
  return (
    <Shell>
      <Sidebar>
        <SidebarHeader>
          <Typography as="h1" $variant="title-5-semibold">Motorik Admin</Typography>
        </SidebarHeader>
        <Nav>
          <SidebarLink to="/admin/invoices">Facturas</SidebarLink>
          <SidebarLink to="/admin/invoice-alerts">Alertas</SidebarLink>
        </Nav>
        <SidebarFooter>
          <BackLink to="/">← Volver a la app</BackLink>
        </SidebarFooter>
      </Sidebar>
      <Main>
        <Outlet />
      </Main>
    </Shell>
  )
}

export default AdminLayout

const Shell = styled.div`
  display: grid;
  grid-template-columns: 240px 1fr;
  min-height: 100vh;
  background-color: #f5f5f5;
  @media (max-width: ${theme.breakpoints.md}) {
    grid-template-columns: 1fr;
  }
`

const Sidebar = styled.aside`
  border-right: 1px solid ${theme.border.defaultWeak};
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  padding: 24px 16px;
  @media (max-width: ${theme.breakpoints.md}) {
    border-right: none;
    border-bottom: 1px solid ${theme.border.defaultWeak};
    padding: 16px;
  }
`

const SidebarHeader = styled.div`
  padding: 0 8px 24px;
`

const Nav = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
`

const SidebarLink = styled(NavLink)`
  padding: 10px 12px;
  border-radius: 8px;
  color: ${theme.colors.defaultStrong};
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  &:hover { background-color: ${theme.fill.defaultMain}; }
  &.active {
    background-color: ${theme.fill.brandMain};
    color: ${theme.colors.inverseStrong || '#fff'};
    font-weight: 600;
  }
`

const SidebarFooter = styled.div`
  padding-top: 16px;
  border-top: 1px solid ${theme.border.defaultWeak};
`

const BackLink = styled(Link)`
  display: block;
  padding: 8px 12px;
  font-size: 13px;
  color: ${theme.colors.defaultWeak};
  text-decoration: none;
  &:hover { color: ${theme.colors.defaultStrong}; }
`

const Main = styled.main`
  padding: 24px 32px;
  overflow-x: auto;
  @media (max-width: ${theme.breakpoints.md}) {
    padding: 16px;
  }
`
